import Header from './components/Header';
import HeroSection from './components/HeroSection';
import { FAQSection, AboutSection, RankingSection, IndexSection } from './components/SectionGroupA';
import { ContactSection, CarouselSection, FeaturesSection } from './components/SectionGroupB';
import { TopicsSection, CardsSection, UpdatesSection } from './components/SectionGroupC';
import { AppSection, CommentsSection, MediaSection } from './components/SectionGroupD';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <FAQSection />
        <AboutSection />
        <RankingSection />
        <IndexSection />
        <ContactSection />
        <CarouselSection />
        <FeaturesSection />
        <TopicsSection />
        <CardsSection />
        <UpdatesSection />
        <AppSection />
        <CommentsSection />
        <MediaSection />
      </main>

      <Footer />
    </div>
  );
}